import { node } from "~/util/dom";
import { ALL_VISUALISERS } from ".";
import GPSSWitchVisualizerSelect from "./select";
import GPSSWitchVisualizerSlider from "./slider";

export type TVisualisation = "select" | "slider" | "";

/**
 * zobrazeni souradnic v simple modu a moznych alternativach
 */
export default class GPSSWitchVisualizer {
	_dom: {
		container: HTMLDivElement;
	};

	_visualization: TVisualisation;

	_gps: any; // Mapy.GPSSwitch

	_slider: GPSSWitchVisualizerSlider;

	_select: GPSSWitchVisualizerSelect;

	_simpleContent: HTMLSpanElement;

	_coordsFormat: Array<string>;

	_coords: any; // SceneCoords

	constructor(visualization: TVisualisation = "") {
		this._dom = {
			container: node("div", { className: "gps" }),
		};

		this._visualization = visualization;

		// @ts-ignore
		this._gps = Mapy.getComponent("gps");

		this._slider = new GPSSWitchVisualizerSlider(this);
		this._select = new GPSSWitchVisualizerSelect(this);

		this._build();

		ALL_VISUALISERS.push(this);
	}

	/**
	 * @destructor
	 */
	destroy() {
		this._slider.destroy();
		this._select.destroy();
		if (ALL_VISUALISERS.indexOf(this) > -1) {
			ALL_VISUALISERS.splice(ALL_VISUALISERS.indexOf(this), 1);
		}
	}

	/**
	 * nasatveni indexu formatu - prepise aktualni pozici ve slideru a format souradnice v simple elementu
	 */
	setFormatIndex() {
		if (!this._coordsFormat) {
			return;
		}

		const formatIndex = this._gps.getFormatIndex() as number;

		this._slider.reorderItems(formatIndex, this._gps.getFormatsCount());
		this._select.selectItem(formatIndex, this._gps.getFormatTrans(formatIndex));
		this._actualizeSimple();
	}

	/**
	 * nasatveni souradnic
	 * @param {Object} coords - nove souradnice
	 */
	setCoords(coords) {
		this._coords = coords;
		this._coordsFormat = this._gps.coordsToAllFormats(coords);
		this._slider.actualizeItems();
		this._select.actualizeItems();
		this._actualizeSimple();

		this.setFormatIndex();
	}

	/**
	 * formatovane souradnice
	 */
	getFormatCoords() {
		return this._coordsFormat;
	}

	/**
	 * nastaveni visualizace
	 */
	setVisualization(visualization: TVisualisation) {
		this._visualization = visualization;
		this._changeVisualization();
	}

	/**
	 * navrati container
	 */
	getContainer() {
		return this._dom.container;
	}

	/**
	 * vytvoreni elementu
	 */
	_build() {
		this._simpleContent = node("span", { className: "gps-simple" });
		this._changeVisualization();
	}

	/**
	 * vyber spravne visualizace dle _visualization
	 */
	_changeVisualization() {
		this._dom.container.innerHTML = "";

		switch (this._visualization) {
			case "slider":
				this._dom.container.appendChild(this._slider.getContainer());
				break;

			case "select":
				this._dom.container.appendChild(this._select.getContainer());
				break;

			default:
				this._dom.container.appendChild(this._simpleContent);
		}
	}

	/**
	 * aktualizace simple elementu
	 */
	_actualizeSimple() {
		this._simpleContent.innerHTML = this._coordsFormat[this._gps.getFormatIndex()];
	}
}
